<nav class="navbar navbar-expand-sm navbar-dark bg-primary">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img src="assets/mock/images/goodgames_icon.svg" alt="GoodGames icon" width="30" height="24"
           class="d-inline-block align-text-top">
    </a>
    <a class="navbar-brand" [routerLink]="'demos'">{{navbarTitle}}</a>

    <!-- Step 3: Toggle the value of the property when the toggler button is clicked. -->
    <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
      &#9776;
    </button>

    <!-- Step 2: Add the ngbCollapse directive to the element below. -->
    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/demos'" (click)="isMenuCollapsed = true">Demos</a>
        </li>
        <li class="nav-item active">
                    <!-- Step 4: Close the menu when a link is clicked. -->
          <a class="nav-link" [routerLink]="'/gamtest-start'" (click)="isMenuCollapsed = true">Selftest</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/welcome'" (click)="isMenuCollapsed = true">Welcome</a>
        </li>
        <li *ngIf="messagesEnabled" class="nav-item">
          <a class="nav-link" [routerLink]="'/messages'" (click)="isMenuCollapsed = true">Messages</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/dialogs/mythbuster'" (click)="isMenuCollapsed = true">Interventions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/design'" (click)="isMenuCollapsed = true">Design</a>
        </li>
      </ul>
      <select *ngIf="cultures.length > 1" class="form-select form-select-sm w-auto ms-sm-auto my-2 my-sm-0"
              aria-label="Language" (change)="selectCulture($any($event.target).value)">
        <option *ngFor="let culture of cultures" [value]="culture.code" [selected]="culture.code === currentCulture">{{culture.name}}</option>
      </select>
    </div>
  </div>
</nav>
